/**
 * Footer component
 *
 * Simple footer with links to legal pages.
 */

/**
 * Footer class - provides legal page links
 */
export class Footer {
  /**
   * Create a new Footer
   * @param {string|HTMLElement} container - Container element or selector
   */
  constructor(container) {
    this.container =
      typeof container === 'string'
        ? document.getElementById(container)
        : container;

    if (!this.container) {
      console.error('Footer: Container not found');
      return;
    }

    this.element = null;
    this.init();
  }

  /**
   * Initialize the footer
   */
  init() {
    this.element = document.createElement('footer');
    this.element.className = 'app-footer';
    this.element.innerHTML = `
      <a href="/impressum">Impressum</a>
      <a href="/datenschutz">Datenschutz</a>
    `;

    // Handle link clicks with client-side routing
    this.element.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const href = link.getAttribute('href');
        window.history.pushState({}, '', href);
        // Trigger popstate event for router
        window.dispatchEvent(new PopStateEvent('popstate'));
      });
    });

    this.container.appendChild(this.element);
  }

  /**
   * Show the footer
   */
  show() {
    if (this.element) {
      this.element.style.display = 'flex';
    }
  }

  /**
   * Hide the footer
   */
  hide() {
    if (this.element) {
      this.element.style.display = 'none';
    }
  }

  /**
   * Clean up
   */
  destroy() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
  }
}
